import React from 'react'
import { createRoot } from 'react-dom/client'
import './utils/dayjsSetup'
import { Amplify } from 'aws-amplify'
import { createStore, applyMiddleware, compose } from 'redux'
import { thunk } from 'redux-thunk'
import { Provider } from 'react-redux'
import rootReducer from './reducers/rootReducer'
import './assets/App.css'
import outputs from './amplify_outputs.json'
import { startNativePushTokenListener } from './utils/nativePushToken'

import App from './App'
import * as serviceWorker from './serviceWorker'

import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

Amplify.configure(outputs)

// Before the first render, so a push token the mobile app sends at page load isn't missed.
startNativePushTokenListener()

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(rootReducer, composeEnhancer(applyMiddleware(thunk)))

const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
const stripePromise = stripePublicKey ? loadStripe(stripePublicKey) : null

const root = createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <Elements stripe={stripePromise}>
      <App />
    </Elements>
  </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
